import { createTheme } from "@mantine/core";

export const theme = createTheme({
  /* Put your mantine theme override here */
  breakpoints: {
    xs: "30em",
    sm: "48em",
    md: "64em",
    lg: "74em",
    xl: "90em",
  },
  cursorType: "pointer",
});
